/**
 * @object envNames
 * @category Config
 * @description Object that de-hardcodes the values of NODE_ENV used across this project.
 */
export const envNames = {
  PROD: 'production',
  DEMO: 'demo',
  STAGING: 'staging',
  DEV: 'development',
  TEST: 'test',
}
